/**
 * Sticky header with the nav and mobile menu.
 *
 * Ported from `public/index.html:40-62`, the mobile toggle (`:600-606`), and the
 * smooth-scroll handler that also closes the menu (`:624-638`).
 */
import logoDark from './assets/logo_dark_web.png';
import logoLight from './assets/logo_light_web.png';

import { useStickyHeader } from '../../hooks/useStickyHeader';

interface Props {
  menuOpen: boolean;
  onToggleMenu: () => void;
  onNavigate: (hash: string) => void;
}

const WelcomeHeader = ({ menuOpen, onToggleMenu, onNavigate }: Props) => {
  const scrolled = useStickyHeader();

  const anchor = (hash: string) => (event: React.MouseEvent) => {
    event.preventDefault();
    onNavigate(hash);
  };

  return (
    <header className={`header${scrolled ? ' scrolled' : ''}`}>
      <div className="header-content">
        <a href="/" className="logo-container">
          <img src={logoLight} alt="LungChat Logo" className="logo-light" />
          <img src={logoDark} alt="LungChat Logo" className="logo-dark" />
        </a>
        <nav className={`nav-links${menuOpen ? ' active' : ''}`}>
          <a href="#about" className="nav-link" onClick={anchor('#about')}>
            About
          </a>
          <a href="#team" className="nav-link" onClick={anchor('#team')}>
            Team
          </a>
          <a href="#faq" className="nav-link" onClick={anchor('#faq')}>
            FAQ
          </a>
          <a
            href="/paper/iclr-2026"
            className="nav-link"
            target="_blank"
            rel="noopener"
          >
            Paper
          </a>
          <a
            href="mailto:pankaj.rajdeo@cchmc.org,nathan.salomonis@cchmc.org,michal.kouril@cchmc.org"
            className="nav-link"
          >
            Contact Us
          </a>
          <a href="/lungchat" className="btn-try-now">
            Try Now
          </a>
        </nav>
        <button
          className={`mobile-menu-btn${menuOpen ? ' active' : ''}`}
          id="mobileMenuBtn"
          onClick={onToggleMenu}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
};

export default WelcomeHeader;
